import { cmsAxios } from "./config/axiosConfig";

export interface KeyType {
  id: string;
  keyTypeName: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

interface KeyTypeListResponse {
  success: boolean;
  data: KeyType[];
}

// Function to fetch key types
export const fetchKeyTypeList = async (): Promise<KeyType[]> => {
  try {
    const response = await cmsAxios.get<KeyTypeListResponse>(
      "/cms/key-type/list"
    );
    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch key types:", error);
    throw error;
  }
};

// Course info nested inside license key
interface CourseDetails {
  id: string;
  courseName: string;
  courseDescription: string;
  isActive: boolean;
  fileId: number;
  categoryTypeId: string;
  createdAt: string;
  updatedAt: string;
}

// Key type info nested inside license key
interface KeyTypeDetails {
  id: string;
  keyTypeName: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

// License key entry
export interface LicenseKey {
  id: string;
  courseId: string;
  keyTypeId: string;
  maxUsers: number;
  currentUsage: number;
  validFrom: string;
  validTill: string;
  numCoursesAllowed: number;
  licenseKey: string;
  isActive: boolean;
  status: string;
  thresholdLimit: number;
  createdAt: string;
  updatedAt: string;
  course_id: string;
  key_type_id: string;
  courseIds: CourseDetails;
  keyTypeIds: KeyTypeDetails;
}

// API response type
interface LicenseKeyListResponse {
  success: boolean;
  data: LicenseKey[];
}

// Function to fetch license key list
export const fetchLicenseKeyList = async (): Promise<LicenseKey[]> => {
  try {
    const response = await cmsAxios.get<LicenseKeyListResponse>(
      "/cms/license-key/list"
    );
    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch license keys:", error);
    throw error;
  }
};

interface CreateLicenseKeyPayload {
  courseId: string;
  keyTypeId: string;
  maxUsers: number;
  numCoursesAllowed: number;
  thresholdLimit: number;
  // validFrom: string;
  // validTill: string;
  licenseKey: string;
  status: "active" | "inactive";
}

export const createLicenseKey = async (payload: CreateLicenseKeyPayload) => {
  try {
    const response = await cmsAxios.post("/cms/license-key/create", payload);
    return response.data;
  } catch (error: any) {
    console.error("Failed to create license key:", error);
    throw error?.response?.data || error;
  }
};

export interface UpdateLicenseKeyPayload {
  courseId: string;
  keyTypeId: string;
  maxUsers: number;
  numCoursesAllowed: number;
  thresholdLimit: number;
  // validFrom: string;
  // validTill: string;
  licenseKey: string;
  status: string;
  isActive: boolean;
}

export const updateLicenseKey = async (
  licenseKeyId: string,
  payload: UpdateLicenseKeyPayload
) => {
  try {
    const response = await cmsAxios.put(
      `/cms/license-key/${licenseKeyId}`,
      payload
    );
    return response.data;
  } catch (error: any) {
    console.error("Failed to update license key:", error);
    throw error?.response?.data || error;
  }
};
